import { render, staticRenderFns } from "./resetUserPassword.vue?vue&type=template&id=e985926e&scoped=true&"
import script from "./resetUserPassword.vue?vue&type=script&lang=js&"
export * from "./resetUserPassword.vue?vue&type=script&lang=js&"
import style0 from "./resetUserPassword.vue?vue&type=style&index=0&id=e985926e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e985926e",
  null
  
)

export default component.exports